import React from "react";
import { FiCheck, FiClock, FiPhoneCall, FiShield } from "react-icons/fi";
import logo from "../../assets/images/Loanonsalary_Logo.png";

const ThankYou1 = () => {
  return (
    <div className="apply-now1-thankyou">
      <div className="apply-now1-thankyou__glow" aria-hidden="true" />
      <div className="apply-now1-thankyou__glow apply-now1-thankyou__glow--alt" aria-hidden="true" />

      <div className="apply-now1-thankyou__badge">
        <img src={logo} alt="Loan on Salary" />
        <span>Application Received</span>
      </div>

      <div className="apply-now1-thankyou__icon-wrap" aria-hidden="true">
        <span className="apply-now1-thankyou__ring" />
        <span className="apply-now1-thankyou__ring apply-now1-thankyou__ring--delay" />
        <span className="apply-now1-thankyou__check">
          <FiCheck />
        </span>
      </div>

      <h1>Thank You!</h1>
      <p className="apply-now1-thankyou__lead">
        Your loan application has been submitted successfully. Our team will review
        your details and get back to you shortly.
      </p>

      <div className="apply-now1-thankyou__points">
        <div className="apply-now1-thankyou__point">
          <span><FiShield /></span>
          <div>
            <strong>Secure submission</strong>
            <small>Your documents are encrypted and protected.</small>
          </div>
        </div>
        <div className="apply-now1-thankyou__point">
          <span><FiClock /></span>
          <div>
            <strong>Quick review</strong>
            <small>Most applications are reviewed within a few hours.</small>
          </div>
        </div>
        <div className="apply-now1-thankyou__point">
          <span><FiPhoneCall /></span>
          <div>
            <strong>We will contact you</strong>
            <small>Expect a call or SMS on your verified mobile.</small>
          </div>
        </div>
      </div>

      <p className="apply-now1-thankyou__note">
        You can safely close this page now.
      </p>
    </div>
  );
};

export default ThankYou1;
